// web/src/components/schedule/DayView.jsx
// One day, full width, with the Daily Board's big tap targets — this is the
// view someone actually works from with a phone in one hand. Same items and
// same grouping as a week column, just given room.

import { groupByBlock, itemsForDate } from '../../lib/schedule';
import ScheduleItem from './ScheduleItem';

export default function DayView({
  date,
  tasks,
  lessons,
  services = [],
  canAdd,
  busy,
  onAdd,
  onOpenItem,
  onFilterPerson,
}) {
  const items = itemsForDate(date, tasks, lessons, services);
  const groups = groupByBlock(items);

  if (items.length === 0) {
    return (
      <div className="text-center py-16">
        <p className="text-ink-500">Nothing scheduled for this day.</p>
        {canAdd && (
          <button onClick={onAdd} className="btn-primary mt-4">
            + Add a Task
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="max-w-2xl">
      {groups.map((g) => (
        <section key={g.id} className="mb-6">
          <h2 className="text-xs font-medium uppercase tracking-wider text-ink-400 mb-2">
            {g.label}
          </h2>
          <div className="space-y-2">
            {g.items.map((item) => (
              <ScheduleItem
                key={item.key}
                item={item}
                variant="full"
                busy={busy}
                onActivate={() => onOpenItem(item)}
                onFilterPerson={onFilterPerson}
              />
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
